// Testi della home in italiano. Nei testi "rich" il tag <b> viene reso in grassetto, <link> come collegamento.
const home = {
  nav: {
    home: "Home",
    services: "Servizi",
    qa: "Quality Assurance",
    products: "Prodotti",
    references: "Referenze",
    about: "Chi siamo",
    workWithUs: "Lavora con noi",
    contact: "Contattaci",
    openMenu: "Apri menu",
    closeMenu: "Chiudi menu",
    menu: "Menu",
  },

  hero: {
    text: "Una software house aumentata dall'AI, governata dalla Quality Assurance. Costruiamo delivery più veloci, controllati e scalabili.",
    ctaServices: "Scopri i servizi",
    ctaTalk: "Parla con noi",
  },

  partners: {
    label: "HANNO SCELTO QAPEX",
    aria: "Partner",
  },

  model: {
    eyebrow: "Il nostro modello",
    title: "Non solo sviluppo software.",
    lead: "L'AI aumenta la velocità. Il vantaggio competitivo nasce quando la velocità resta <b>governata</b>. Uniamo AI pipeline, sviluppo e Quality Assurance in un unico flusso operativo.",
    agentic: {
      title: "AGENTIC ENGINEERING",
      text: "Pipeline di AI e automazione che accelerano analisi, sviluppo e documentazione su progetti di qualsiasi dimensione, anche in cloud.",
    },
    qa: {
      title: "QUALITY ASSURANCE",
      text: "QA strutturata e integrata in ogni fase: controllo, metodo e affidabilità del processo e del prodotto. L'AI non sostituisce l'ingegneria: la amplifica.",
    },
  },

  services: {
    eyebrow: "I nostri servizi",
    title: "Servizi modulari, qualità integrata.",
    lead: "Per accelerare roadmap digitali, automazioni e applicazioni cloud-native.",
    items: [
      { title: "DevOps in Cloud", text: "Pipeline CI/CD, infrastruttura as code e ambienti cloud scalabili, monitorati e sicuri." },
      { title: "Pipeline AI di Business", text: "Automazioni intelligenti che accelerano analisi, documentazione e processi aziendali." },
      { title: "AI Locale & Modelli Custom", text: "Modelli AI privati o on-premise, addestrati sui tuoi dati senza esporli all'esterno." },
      { title: "Web & Mobile Cloud-Native", text: "Siti, e-commerce e app progettati per scalare: veloci, usabili e orientati alla conversione." },
      { title: "Ottimizzazione & Performance", text: "Analisi, load testing e tuning per applicazioni più rapide, stabili e affidabili." },
      { title: "AI Code Assurance", text: "Verifichiamo il codice generato dall'AI: review, test e governance prima di ogni rilascio." },
    ],
  },

  qa: {
    eyebrow: "Quality Assurance · Nati per il test automation",
    title: "Quality is",
    titleHighlight: "not accidental.",
    lead: "La QA non rallenta il delivery: lo rende sostenibile. Team certificati ISTQB, AI proprietaria e automazione in ogni ciclo di rilascio.",
    cards: [
      {
        tag: "END-TO-END",
        title: "QA Service Provider",
        text: "Il cuore della nostra offerta: gestione end-to-end e scalabile del testing. Testbook su misura con AI proprietaria, cicli di test funzionali, di sistema e di integrazione, regressioni tracciate a ogni push.",
        chips: ["Gestione end-to-end", "Scalabilità garantita", "Qualità continua"],
      },
      {
        tag: "PREMIUM",
        title: "QA Consulting",
        text: "Consulenti con esperienza corporate e competenze trasversali: \"dualisti\" che padroneggiano test manuali e automazione, con l'AI integrata nei processi quotidiani.",
        chips: ["Expertise certificata", "Adattabilità immediata", "Competenza ibrida"],
      },
    ],
    cert: {
      eyebrow: "Certificazione Qapex",
      title: "Testa con Qapex.",
      titleLine2: "Rilascia con il nostro certificato.",
      discover: "Scopri come ottenerla",
      text: "Se scegli Qapex per il testing del tuo software, al termine del ciclo rilasciamo la <b>Certificazione Qapex Quality Assured</b>: un attestato interno che documenta copertura, esiti e qualità del rilascio, da condividere con clienti, partner e stakeholder.",
      certTitle: "CERTIFICATO DI QUALITÀ",
      project: "Progetto: Nome applicazione · release 2.4",
      kpis: ["Test eseguiti", "Copertura", "Bug critici"],
      date: "12/10/2026",
      dateLabel: "Data di rilascio",
    },
  },

  // Pagina /certificazione-qapex (titolo, testo ed esempio di certificato sono in qa.cert)
  certPage: {
    howEyebrow: "Come si ottiene",
    howTitle: "Quattro passaggi, dai requisiti al certificato.",
    howLead: "Il certificato è il risultato di un ciclo di test completo, eseguito dal nostro team certificato ISTQB.",
    steps: [
      { title: "Analisi requisiti & Testbook AI", text: "Analizziamo i requisiti del tuo software e, con la nostra AI proprietaria, prepariamo un testbook su misura: i casi di test da eseguire." },
      { title: "Esecuzione dei cicli di test", text: "Eseguiamo i cicli di test funzionali, di sistema e di integrazione, con le regressioni tracciate a ogni rilascio." },
      { title: "Report di qualità e tracciabilità", text: "Raccogliamo esiti, copertura e difetti in un report di qualità, con la tracciabilità tra requisiti e test." },
      { title: "Rilascio del certificato", text: "Al termine del ciclo rilasciamo la Certificazione Qapex Quality Assured, pronta da condividere con clienti, partner e stakeholder." },
    ],
    ctaTitle: "Vuoi certificare il tuo prossimo rilascio?",
    ctaText: "Raccontaci il tuo progetto: ti proponiamo il ciclo di test più adatto. Il primo consulto è gratuito.",
    cta: "Richiedi un ciclo di test",
  },

  process: {
    eyebrow: "Come lavoriamo",
    title: "Dall'idea al rilascio, con la QA in ogni sprint.",
    lead: "Cicli brevi, validazione continua e qualità integrata. Roadmap tecnica e piano QA restano sincronizzati: uno definisce cosa si costruisce, l'altro come si verifica.",
    steps: [
      { phase: "KICKOFF", title: "Obiettivi chiari", text: "Definizione di obiettivi, criteri di successo e allineamento su stack tecnologico e vincoli." },
      { phase: "SPRINT CICLICI", title: "Sviluppo verificato", text: "Sviluppo con review tecniche e QA checkpoint integrati in ogni sprint, non solo alla fine." },
      { phase: "GO-LIVE", title: "Rilascio sicuro", text: "Checklist di qualità, piano di monitoraggio e roadmap di miglioramento continuo." },
    ],
  },

  products: {
    eyebrow: "I nostri prodotti",
    title: "Strumenti AI proprietari.",
    demo: "Richiedi una demo",
    quack: {
      text: "Carica audio, video, note o foto di lavagne: ottieni analisi funzionale, backlog e change request pronti in .docx e .pdf.",
      cta: "Scopri QUACK",
      play: "Guarda il video di presentazione di QUACK",
      tools: "Strumenti",
      steps: ["Riunione", "Backlog", "Change Request"],
      running: "Analisi in corso…",
    },
    subq: {
      text: "Work in progress",
      cta: "Scopri SubQ",
    },
  },

  certs: {
    eyebrow: "Certificazioni",
    title: "Standard internazionali, verificabili.",
    lead: "Il nostro team è certificato secondo gli standard di riferimento per la qualità del software.",
    active: "✓ ATTIVA · 2026",
    planned: "PIANIFICATA · 2026–2028",
    istqb: "International Software Testing Qualifications Board, riconosciuto in oltre 120 paesi.",
    iso9001: "Sistema di gestione per la qualità dei processi aziendali.",
    iso27001: "Sicurezza delle informazioni e protezione dei dati.",
  },

  refs: {
    eyebrow: "Referenze",
    title: "Cosa dicono di noi.",
    carousel: "carosello",
    goTo: "Recensione {n}",
    items: {
      stefanetti: {
        role: "Fondatore, Symposium Group",
        text: "Abbiamo scelto Qapex per sviluppare l'applicazione della nostra community e ci siamo trovati veramente bene: ragazzi giovani con voglia di fare, attenti alla qualità, ai dettagli e soprattutto alla rapidità. Ve li consiglio con tutto il cuore.",
      },
      pettini: {
        role: "CTO, Engineer, Teacher",
        text: "Nima e il suo team si sono presi in carico tutti gli aspetti del testing dell'intero servizio ParkingMyCar, hanno introdotto metodologie di test e sviluppato un framework di test automation, garantendo qualità a ogni nostro rilascio. È stato un ottimo investimento.",
      },
      innamorati: {
        role: "Connecting the finest SAP Professionals worldwide",
        text: "Qapex ha consulenti con cui tutti vorrebbero lavorare. Sono molto competenti, oltre che pienamente coinvolti e umili. Hanno risolto con tempestività molti problemi legati alla fase di test di diversi progetti.",
      },
      picciotto: {
        role: "QA Specialist, Competence Center & Offering Management",
        text: "Sempre disponibili e pronti a mettersi in gioco. Se c'è un progetto da fare, so di poter contare su Nima ed il suo team per consegnarlo con qualità.",
      },
      lombardozzi: {
        role: "Program Manager",
        text: "Un professionista con spiccato problem solving, ottime soft skills ed eccellente capacità di comunicazione. Le sue idee sono sempre risultate sfidanti, accrescendo qualità ed efficienza dei progetti.",
      },
    },
  },

  contact: {
    eyebrow: "Contatti",
    title: "Pronto a trasformare il tuo business?",
    lead: "Parliamone insieme. Il nostro team è a disposizione per costruire con te soluzioni digitali personalizzate. Il primo consulto è gratuito.",
    email: "Email",
    office: "Sede",
    officeValue: "Via della Louvière 1/A, 06034 Foligno (PG)",
    vat: "P.IVA",
    formTitle: "Scrivici",
    firstName: "Nome",
    firstNamePlaceholder: "Mario",
    lastName: "Cognome",
    lastNamePlaceholder: "Rossi",
    emailPlaceholder: "mario@azienda.it",
    phone: "Numero di telefono",
    phonePrefix: "Prefisso",
    phonePlaceholder: "333 123 4567",
    service: "Servizio di interesse",
    selectService: "Seleziona un'opzione",
    message: "Messaggio",
    messagePlaceholder: "Come possiamo esserti di aiuto?",
  },

  footer: {
    tagline: "Costruiamo software con la velocità dell'AI e il rigore della QA. Da Foligno, nel cuore verde dell'Umbria.",
    navigate: "NAVIGA",
    company: "AZIENDA",
    legal: "LEGAL",
    contacts: "Contatti",
    privacy: "Privacy Policy",
    cookies: "Cookie Policy",
    legalNotes: "Note legali",
    rights: "QAPEX S.r.l. · P.IVA IT03818350542 · All rights reserved.",
  },

  video: {
    dialog: "Video",
    close: "Chiudi video",
  },
};

export default home;
